import { SendOfferEvent } from "@domain";
import { BasePeerCommand } from "./BasePeerCommand";
import { RoomStreamingBloc } from "../../../RoomStreamingBloc";
import { SignalingService } from "../../../services";

export class SendOfferCommand extends BasePeerCommand {
  constructor(bloc: RoomStreamingBloc, signalingService: SignalingService) {
    super(bloc, signalingService);
  }

  public execute(event: CustomEvent<SendOfferEvent>): void {
    const room = this.getRoom();
    this.signalingService.sendOffer(
      room.id,
      event.detail.description,
      this.getRoomLocalParticipantRemoteId(),
      event.detail.to
    );
  }
}
